var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg7(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 230 301.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f2d7cc;}.cls-2{fill:#ee8eb4;}.cls-3{fill:#343231;}.cls-4{fill:#e50012;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uB808\\uC774\\uC5B4_2",
    "data-name": "\\uB808\\uC774\\uC5B4 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uB808\\uC774\\uC5B4_1-2",
    "data-name": "\\uB808\\uC774\\uC5B4 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M132.9,229.33H83.11a128.81,128.81,0,0,1-38.6,27.35s9.1,34,12,44.72c0,0,103.55-16.5,163-86.49l-13.86-8.41A126.63,126.63,0,0,1,132.9,229.33Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 230,
    height: 230,
    rx: 43.52
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 33.31,
    cy: 129.98,
    r: 14.29,
    transform: "translate(-100.18 143.59) rotate(-81.45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 196.69,
    cy: 129.98,
    r: 14.29,
    transform: "translate(-26.86 204.87) rotate(-51.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M143.68,133.84a10.31,10.31,0,0,1,9.22,14.93c-6.43,12.94-21,22-37.9,22s-31.47-9-37.9-22a10.31,10.31,0,0,1,9.22-14.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M56.09,103.12a46.36,46.36,0,0,1-3.51-3.21C47.79,95.05,42,87,44.38,79.83,46.18,74.25,52.74,72.6,58,73a22.72,22.72,0,0,1,8.25,2.27,28.73,28.73,0,0,1,3.11,1.64,1.5,1.5,0,0,0,2.31-1.2c.24-4.81,1.95-9.84,6.27-12.17,4.7-2.55,9.88-.86,13.35,2.91,5.58,6,5,14.39,2.7,21.74a95.2,95.2,0,0,1-6.16,15c-1.36,2.62-2.52,5.51-4.5,7.75-3.45,3.92-8.5,2.94-12.75,1A63.86,63.86,0,0,1,56.09,103.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M173.91,103.12a46.36,46.36,0,0,0,3.51-3.21c4.79-4.86,10.54-12.87,8.2-20.08-1.8-5.58-8.36-7.23-13.6-6.87a22.72,22.72,0,0,0-8.25,2.27,28.73,28.73,0,0,0-3.11,1.64,1.5,1.5,0,0,1-2.31-1.2c-.24-4.81-1.95-9.84-6.27-12.17-4.7-2.55-9.88-.86-13.35,2.91-5.58,6-5,14.39-2.7,21.74a95.2,95.2,0,0,0,6.16,15c1.36,2.62,2.52,5.51,4.5,7.75,3.45,3.92,8.5,2.94,12.75,1A63.86,63.86,0,0,0,173.91,103.12Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg7);
export default __webpack_public_path__ + "static/media/7.b533951175420ee03ad5e3287eed233a.svg";
export { ForwardRef as ReactComponent };